import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import createStyles from '@material-ui/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import useTheme from '@material-ui/core/styles/useTheme';
import cx from 'classnames';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { colors } from '../theme';
import { IConfig } from '../../src/store/types';
import { SENDER_UI_URL } from '../common/constants';

const styles = (theme: Theme) =>
  createStyles({
    actions: {
      marginTop: 0,
      padding: 0,
      justifyContent: 'center',
      display: 'flex',
      flexDirection: 'column',
    },
    termsContainer: {
      textAlign: 'center',
    },
    modalContainer: {
      padding: '32px 0 26px',
      width: '490px',
    },
    responseModalContainer: {
      overflow: 'hidden',
      padding: `${theme.spacing(5)}px ${theme.spacing(3)}px`,
      width: 'auto',
    },
    dialogContent: {
      color: colors.dusk,
      width: '432px',
      margin: '0 auto',
      padding: '17px 8px 24px',
    },
    responsiveDialogContent: {
      width: 'auto',
      padding: `${theme.spacing(2)}px 0 ${theme.spacing(3)}px`,
      textAlign: 'center',
    },
    termsTitle: {
      fontSize: '26px',
      color: colors.dusk,
      marginBottom: `${theme.spacing()}px`,
    },
    agreeBtn: {
      marginBottom: `${theme.spacing(2)}px`,
    },
    responsiveAgreeBtn: {
      marginBottom: `${theme.spacing(3)}px`,
    },
    exitBtn: {
      padding: 0,
    },
  });

interface IProps extends WithStyles<typeof styles> {
  accepted: boolean;
  acceptTerms: Function;
  visible: boolean;
  loading: boolean;
  exitSigning: Function;
  config: IConfig;
}

const Terms = (props: IProps) => {
  const { classes, visible, acceptTerms, exitSigning, loading, config } = props;
  const theme = useTheme();
  let isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
  isFullScreen = isFullScreen ? true : false;
  const modalClass = isFullScreen ? cx(classes.modalContainer, classes.responseModalContainer) : classes.modalContainer;
  const dialogContentClass = isFullScreen
    ? cx(classes.dialogContent, classes.responsiveDialogContent)
    : classes.dialogContent;
  const agreeBtnClass = isFullScreen ? cx(classes.agreeBtn, classes.responsiveAgreeBtn) : classes.agreeBtn;
  const urlParams = new URLSearchParams(window.location.search);
  const signNow = urlParams.get('signNow');

  const handleExit = () => {
    if (signNow) {
      if (config.senderUi.sendRedirectUrl) {
        window.location.href = config.senderUi.sendRedirectUrl;
      } else {
        window.location.href = SENDER_UI_URL;
      }
    } else {
      exitSigning();
    }
  };

  const eSignAgreementUrl =
    config && config.eSignAgreementUrl
      ? config.eSignAgreementUrl
      : 'https://portal.title.com/assets/documents/esignterms-e1efc6c4.pdf';

  return (
    <Dialog
      open={visible}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disablePortal
      className={classes.termsContainer}
      fullScreen={isFullScreen}
    >
      <div className={modalClass}>
        <div className={classes.termsTitle}>Accept e-signature terms</div>
        <DialogContent className={dialogContentClass}>
          <DialogContentText id="alert-dialog-description">
            I have read and acknowledge the{' '}
            <a href={eSignAgreementUrl} target="_blank">
              ESIGN Consumer Disclosure and Consent
            </a>
            , and I agree to do business electronically.
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.actions}>
          <Button
            onClick={() => acceptTerms()}
            color="primary"
            onTouchEnd={() => acceptTerms()}
            autoFocus
            variant="contained"
            size="medium"
            className={agreeBtnClass}
            focusRipple={false}
            disabled={loading}
          >
            I Agree
          </Button>
          <Button
            color="primary"
            onClick={() => handleExit()}
            onTouchEnd={() => handleExit()}
            className={classes.exitBtn}
          >
            Exit Signing
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default withStyles(styles)(Terms);
